import React from 'react';
import { Button, Group, Icon, Dialog } from '@economic/taco';

import { t } from '../l10n/l10n';

interface Props {
    label: string;
    message?: string;
    closeText?: string;
    onClose: () => any;
    warning?: boolean;
    children?: React.ReactNode;
}

export default function InfoDialog({ label, message, children, onClose, closeText, warning = false }: Props) {
    return (
        <>
            <Dialog.Title>
                {warning && <Icon name="warning" className="rounded-full yt-yellow-solid mr-4" />}
                {label}
            </Dialog.Title>

            {message}
            {children}

            <Dialog.Footer>
                <Group>
                    <Button onClick={onClose} appearance="primary" autoFocus>
                        {closeText || t`BUTTON_OK`}
                    </Button>
                </Group>
            </Dialog.Footer>
        </>
    );
}
